"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Label = _interopRequireDefault(require("../Label"));
var _constant = require("./constant");
var _InfoIcon = _interopRequireDefault(require("./InfoIcon"));
var _shimmerButton = _interopRequireDefault(require("./shimmerButton.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SHIMMER_COLOR = _constant.DEFAULT_SHIMMER_BUTTON.SHIMMER_COLOR;
var ShimmerContainer = _styledComponents.default.div.withConfig({
  displayName: "ShimmerButton__ShimmerContainer",
  componentId: "sc-el4bd7-0"
})(["width:", ";height:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var ShimmerLoader = _styledComponents.default.span.withConfig({
  displayName: "ShimmerButton__ShimmerLoader",
  componentId: "sc-el4bd7-1"
})(["display:block;height:100%;", " border-radius:", ";background-size:200%;background-position:0 0;animation:load 1.2s linear infinite normal both;@keyframes load{0%{background-position:200% 0;}70%{background-position:100% 0;}100%{background-position:0 0;}}"], function (props) {
  return !props.colorAnimation && (0, _styledComponents.css)(["background:linear-gradient( 75deg,", " 45%,", " 52%,", " 57% );"], props.buttonColor, props.shimmerColor || SHIMMER_COLOR, props.buttonColor);
}, function (props) {
  return props.borderRadius;
});
var PromoContainer = _styledComponents.default.div.withConfig({
  displayName: "ShimmerButton__PromoContainer",
  componentId: "sc-el4bd7-2"
})(["display:flex;border-radius:4px;padding:1px;align-items:center;justify-content:center;color:white;position:relative;"]);
var PromoContainerLeft = _styledComponents.default.div.withConfig({
  displayName: "ShimmerButton__PromoContainerLeft",
  componentId: "sc-el4bd7-3"
})(["display:flex;flex-direction:column;align-items:flex-end;font-family:'DM Sans';font-size:12px;font-style:normal;font-weight:500;line-height:16px;"]);
var PromoContainerRight = _styledComponents.default.div.withConfig({
  displayName: "ShimmerButton__PromoContainerRight",
  componentId: "sc-el4bd7-4"
})(["display:flex;"]);
var ShimmerButton = function ShimmerButton(props) {
  var width = props.width,
    height = props.height,
    borderRadius = props.borderRadius,
    theme = props.theme,
    buttonTextTop = props.buttonTextTop,
    buttonTextBottom = props.buttonTextBottom,
    buttonColor = props.buttonColor,
    shimmerColor = props.shimmerColor,
    accessible = props.accessible,
    customProperties = props.customProperties,
    colorAnimation = props.colorAnimation,
    handleMouseEnter = props.handleMouseEnter,
    handleMouseLeave = props.handleMouseLeave,
    isShowIcon = props.isShowIcon;
  var tabIndex = !accessible ? '-1' : '0';
  var _useState = (0, _react.useState)({
      top: 0,
      left: 0,
      height: 0
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    popoverPosition = _useState2[0],
    setPopoverPosition = _useState2[1];
  var promoContainerRef = (0, _react.useRef)(null);
  var calculatePopoverPosition = function calculatePopoverPosition() {
    if (promoContainerRef.current) {
      var rect = promoContainerRef.current.getBoundingClientRect();
      setPopoverPosition({
        top: rect.top,
        left: rect.left + rect.width / 2,
        height: rect.height
      });
    }
  };
  var handleMouseEnterCalled = function handleMouseEnterCalled(e) {
    e.preventDefault();
    handleMouseEnter(popoverPosition);
    calculatePopoverPosition();
  };
  var handleMouseLeaveCalled = function handleMouseLeaveCalled(e) {
    e.preventDefault();
    handleMouseLeave(popoverPosition);
  };
  (0, _react.useEffect)(function () {
    calculatePopoverPosition(); // Calculate position on mount
    window.addEventListener('resize', calculatePopoverPosition); // Recalculate on window resize
    return function () {
      window.removeEventListener('resize', calculatePopoverPosition); // Clean up event listener
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ShimmerContainer, (0, _extends2.default)({
    width: width,
    height: height,
    tabIndex: tabIndex
  }, customProperties), /*#__PURE__*/_react.default.createElement(ShimmerLoader, {
    borderRadius: borderRadius,
    colorAnimation: colorAnimation,
    buttonColor: buttonColor,
    shimmerColor: shimmerColor
  }, /*#__PURE__*/_react.default.createElement(PromoContainer, {
    ref: promoContainerRef,
    onMouseEnter: handleMouseEnterCalled,
    onMouseLeave: handleMouseLeaveCalled
  }, /*#__PURE__*/_react.default.createElement(PromoContainerLeft, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    customProperties: _objectSpread(_objectSpread({}, customProperties), {}, {
      textAlign: 'right'
    })
  }, buttonTextTop), /*#__PURE__*/_react.default.createElement(_Label.default, {
    customProperties: customProperties
  }, buttonTextBottom)), isShowIcon && /*#__PURE__*/_react.default.createElement(PromoContainerRight, null, /*#__PURE__*/_react.default.createElement(_InfoIcon.default, null))))));
};
ShimmerButton.propTypes = _shimmerButton.default.PropTypes;
ShimmerButton.defaultProps = _shimmerButton.default.DefaultProps;
var _default = ShimmerButton;
exports.default = _default;